<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-12">
        <h1>Book survey</h1>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="col-6">
        <p>
          {{ survey.customer }}<br />
          <span v-if="survey.customerAddressOne">{{ survey.customerAddressOne }}, <br /></span>
          <span v-if="survey.customerAddressTwo">{{ survey.customerAddressTwo }}, <br /></span>
          <span v-if="survey.customerAddressThree">{{ survey.customerAddressThree }}, <br /></span>
          <span v-if="survey.customerAddressFour">{{ survey.customerAddressFour }}, <br /></span>
          <span v-if="survey.customerAddressFive">{{ survey.customerAddressFive }}, <br /></span>
          <span v-if="survey.customerPostcode">{{ survey.customerPostcode }}</span>
        </p>
        <p>
          Area(s) to be surveyed:<br />
          <span v-if="survey.external">External</span>
          <span v-if="survey.internal">Internal</span>
        </p>
      </v-col>
      <v-col class="col-6">
        Site address: {{ survey.address }}<br />
        Contact: {{ survey.contact }}<br />
        Contact number: {{ survey.contact_number }}<br />
        Booking notes: {{ survey.booking_notes }}<br />
        Requested by: {{ survey.requestor }}
      </v-col>
    </v-row>
      <v-row v-if="survey.customer !== 0">
        <v-col class="col-10 col-sm-6 col-md-4">
          <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  @click:append="resetDate"
                  :value="prettyDate"
                  label="Survey date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  suffix="*"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row v-if="survey.customer !== 0">
        <v-col class="col-10 col-sm-6 col-md-4">
          <v-select label="AM or PM" v-model="survey.am" :items="[{ value: 1, text: 'AM'}, { value: 0, text: 'PM'}]"></v-select>
        </v-col>
      </v-row>
      <v-row v-if="survey.customer !== 0">
        <v-col class="col-10 col-sm-6 col-md-4">
          <v-select
              :items="users"
              v-model="survey.surveyed_by"
              item-text="text"
              item-value="value"
              label="To be surveyed by"
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="survey.customer !== 0">
        <v-col class="col-10 col-sm-6 col-md-4">
          <v-select
              :items="vehicles"
              v-model="survey.vehicle"
              item-text="text"
              item-value="value"
              label="Vehicle"
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="survey.customer !== 0">
        <v-col class="col-10 col-sm-6 col-md-4">
          <v-btn @click="saveSurvey">Save</v-btn>
        </v-col>
      </v-row>
    <v-dialog
        v-model="showMessage"
        max-width="290"
    >
      <v-card>
        <v-card-text class="pt-4">
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="orange darken-2"
              text
              @click="finish"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from '../../axios';
import { format, parseISO } from 'date-fns';

export default {
  name: 'BookQuotation',
  data() {
    return {
      customer: {},
      menu: false,
      survey: {
        booking_notes: '',
        contact_number: '',
        customer: 0,
        date: null,
        address: '',
        am: true,
      },
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      prettyDate: format(parseISO((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)), 'EEEE, MMMM do yyyy'),
      message: '',
      showMessage: false,
      users: [],
      vehicles: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    userid() {
      return this.$store.state.userid;
    },
  },
  watch: {
    date() {
      this.prettyDate = format(parseISO(this.date), 'EEEE, MMMM do yyyy');
      this.quotation.date = this.date;
    },
  },
  methods: {
    finish() {
      this.$router.push('/surveys/index');
    },
    getSurvey() {
      axios.get(`/siteSurveys/getOne/${this.$route.params.id}.json?token=${this.token}`)
          .then((response) => {
            this.survey = response.data.survey;
            if (response.data.survey.am) {
              this.survey.am = 1;
            } else {
              this.survey.am = 0;
            }
          });
    },
    getUsers() {
      axios.get(`/users/getSurveyors.json?token=${this.token}`)
          .then((response) => {
            this.users = response.data.users;
          });
    },
    getVehicles() {
      axios.get(`/vehicles/getForSurveys.json?token=${this.token}`)
          .then((response) => {
            this.vehicles = response.data.vehicles;
          });
    },
    saveSurvey() {
      const postData = {};
      postData.survey = this.survey;
      postData.date = this.date;
      axios.post(`/siteSurveys/bookSurvey.json?token=${this.token}&user=${this.userid}`, postData)
          .then((response) => {
            this.message = response.data.message;
            this.showMessage = true;
          });
    },
    resetDate() {
      this.prettyDate = null;
      this.date = null;
      this.quotation.date = null;
    },
  },
  mounted() {
    this.getSurvey();
    this.getUsers();
    this.getVehicles();
  }
}
</script>
